var map = {
	"./00002.jpg": 4588,
	"./1.jpg": 7099,
	"./129248816_404993970741235_2660202030048459111_n.jpg": 5687,
	"./132035427_233510954825703_4564234259399533362_n.jpg": 7378,
	"./2.jpg": 5116,
	"./2025-07-29-13-32-45-880.jpg": 5389,
	"./20250923_020708.jpg": 1059,
	"./20251101_230410.jpg": 1601,
	"./29.jpg": 3955,
	"./4.jpg": 5274,
	"./IMG_20250617_233145_186.jpg": 2754,
	"./MAIN.jpg": 1295,
	"./MAINs.jpg": 2560,
	"./headPic (2).jpg": 159,
	"./headPic (3).jpg": 6524,
	"./headPic (4).jpg": 3473,
	"./headPic (5).jpg": 1958,
	"./headPic (6) - 複製.jpg": 8244,
	"./headPic (6).jpg": 9611,
	"./headPic.jpg": 2376,
	"./id1_headPic.jpg": 741,
	"./id2_headPic.jpg": 2950,
	"./p4.jpg": 5056,
	"./sketch1629039853031.jpg": 8064,
	"./sketch1643641203920.jpg": 1939,
	"./sketch1760253890346.jpg": 3698,
	"./螢幕擷取畫面 2023-11-03 105649.jpg": 3188,
	"./螢幕擷取畫面 2024-01-07 203033.jpg": 6700,
	"./螢幕擷取畫面 2024-08-30 120056.jpg": 4450,
	"./螢幕擷取畫面 2024-09-09 144030.jpg": 3313,
	"./螢幕擷取畫面 2024-11-27 122033.jpg": 7853,
	"./裝置.jpg": 921,
	"./資產 3.jpg": 2044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3696;